export const state = {
  item: ""
};

export const mutations = {
  includeItem(state, item) {
    state.item.exclude = true;
  }
};

export const getters = {};

export const actions = {
  updateStatus({ commit }, item) {
    return new Promise((resolve, reject) => {
      commit("includeItem", item);
    });
  }
};
